import { useCallback, useState } from 'react';
import { fetchQuery } from 'relay-runtime';
import { createAri } from '@atlassian/jira-platform-ari';
import getRelayEnvironment from '@atlassian/jira-relay-environment';
import aggBacklogDataQuery, {
	type aggBacklogDataQuery as aggBacklogDataQueryType,
} from '@atlassian/jira-relay/src/__generated__/aggBacklogDataQuery.graphql';

export const useGetDataFromAGG = ({ cloudId, boardId }: { cloudId: string; boardId: number }) => {
	const [fetchError, setFetchError] = useState<unknown>();
	const getDataFromAGG = useCallback(
		async (captureError = false) => {
			const boardAri = createAri({
				resourceOwner: 'jira-software',
				cloudId,
				resourceType: 'board',
				resourceId: String(boardId),
			});

			const variables = {
				boardId: boardAri,
				cloudId,
			};

			const fetchResponse$ = fetchQuery<aggBacklogDataQueryType>(
				getRelayEnvironment(),
				aggBacklogDataQuery,
				variables,
			);
			fetchResponse$.subscribe({ error: captureError ? setFetchError : undefined });

			const responseData = await fetchResponse$.toPromise();

			if (!responseData) {
				throw new Error(`${aggBacklogDataQuery.params.name} returned undefined`);
			}

			return responseData;
		},
		[boardId, cloudId],
	);

	if (fetchError) {
		throw fetchError;
	}
	return getDataFromAGG;
};
